module.exports = __webpack_public_path__ + "img/moreend.8cadd6df.png";